//#region src/integrations/google/googleTypes.ts
const GOOGLE_INTEGRATION_ID = "google";

//#endregion
export { GOOGLE_INTEGRATION_ID };
//# sourceMappingURL=googleTypes.js.map